"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Scale = require("./Scale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      marginTop: 24
    },
    marker: {
      position: "absolute",
      top: 0,
      transition: theme.transitions.create(["left", "opacity"])
    },
    label: {
      position: "absolute",
      transform: "translateX(-50%)",
      top: -20
    },
    pointer: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "visible",
      "&:before": {
        content: "''",
        display: "block",
        border: "6px solid transparent",
        marginLeft: -6,
        borderTopColor: "currentColor"
      }
    }
  };
};
/**
 * Marks a point along the scale
 */


var Marker = function Marker(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      value = _ref.value,
      label = _ref.label,
      pointerColor = _ref.pointerColor,
      props = _objectWithoutProperties(_ref, ["classes", "className", "value", "label", "pointerColor"]);

  var _useScaleContext = (0, _Scale.useScaleContext)(),
      type = _useScaleContext.type,
      position = _useScaleContext.position,
      color = _useScaleContext.color,
      margin = _useScaleContext.margin;

  var hasValue = (value || value === 0) && isNaN(value) === false;
  var leftPosition = !hasValue ? 0 : type === "category" ? position(value) + position.bandwidth() / 2 : position(value);
  var markerColor = hasValue ? color(value) : "transparent";
  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    className: (0, _clsx["default"])(classes.root, className),
    position: "relative",
    style: {
      marginLeft: margin.left,
      marginRight: margin.right
    }
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])("HypScale-marker", classes.marker, className),
    style: {
      left: leftPosition * 100 + "%",
      opacity: hasValue ? 1 : 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])("HypScale-pointer", classes.pointer),
    style: {
      color: pointerColor || markerColor
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "caption",
    component: "span",
    className: (0, _clsx["default"])("HypScale-label", classes.label)
  }, label)));
};

Marker.propTypes = {
  /** The value of the marker (used for positioning) */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Label for the marker */
  label: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Color of the pointer */
  pointerColor: _propTypes["default"].string
};
Marker.__docgenInfo = {
  "description": "Marks a point along the scale",
  "methods": [],
  "displayName": "Marker",
  "props": {
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "The value of the marker (used for positioning)"
    },
    "label": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Label for the marker"
    },
    "pointerColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Color of the pointer"
    }
  }
};

var _default = (0, _core.withStyles)(styles)(Marker);

exports["default"] = _default;